import React from 'react';
import { Navigate } from 'react-router-dom';
import Dashboard from '../pages/dashboard/Dashboard.jsx';
import Users from '../pages/users/Users.jsx';
import TenantProfile from '../pages/profile/TenantProfile.jsx';
import Packages from '../pages/packages/Packages.jsx';
import CreatePackage from '../pages/packages/CreatePackage.jsx';
import DetailPackage from '../pages/packages/DetailPackage.jsx';
import Promotions from '../pages/promotions/Promotions.jsx';
import CreatePromotion from '../pages/promotions/CreatePromotion.jsx';
import DetailPromotion from '../pages/promotions/DetailPromotion.jsx';
import TenantCosts from '../pages/tenant_costs/TenantCosts.jsx';
import CreateTenantCost from '../pages/tenant_costs/CreateTenantCost.jsx';
import DetailTenantCost from '../pages/tenant_costs/DetailTenantCost.jsx';
import ClosingSchedule from '../pages/closing-schedule/ClosingSchedule.jsx';
import CreateClosingSchedule from '../pages/closing-schedule/CreateClosingSchedule.jsx';
import DetailClosingSchedule from '../pages/closing-schedule/DetailClosingSchedule.jsx';
import Bookings from '../pages/bookings/Bookings.jsx';
import BookingDetail from '../pages/bookings/BookingDetail.jsx';
import Withdrawl from '../pages/withdrawl/Withdrawl.jsx';
import BankAccount from '../pages/bank-account/BankAccount.jsx';
import CreateBankAccount from '../pages/bank-account/CreateBankAccount.jsx';
import DetailBankAccount from '../pages/bank-account/DetailBankAccount.jsx';
import Review from '../pages/review/Review.jsx';
import WithdrawlDetail from '../pages/withdrawl/WithdrawlDetail.jsx';
import Income from '../pages/income/Income.jsx';
import Expense from '../pages/expense/Expense.jsx';
import Cashflow from '../pages/cashflow/Cashflow.jsx';

export const OwnerRoutes = [
  {
    path: '',
    children: [
      {
        path: '',
        element: <Dashboard />
      },
      {
        path: '/users',
        element: <Users />
      },
      {
        path: '/profile',
        element: <TenantProfile />
      },
      {
        path: '/closing-schedule',
        element: <ClosingSchedule />
      },
      {
        path: '/closing-schedule/create',
        element: <CreateClosingSchedule />
      },
      {
        path: '/closing-schedule/detail/:id',
        element: <DetailClosingSchedule />
      },
      {
        path: '/promotions',
        element: <Promotions />
      },
      {
        path: '/promotions/create',
        element: <CreatePromotion />
      },
      {
        path: '/promotions/detail/:id',
        element: <DetailPromotion />
      },
      {
        path: '/packages',
        element: <Packages />
      },
      {
        path: '/packages/create',
        element: <CreatePackage />
      },
      {
        path: '/packages/detail/:slug',
        element: <DetailPackage />
      },
      {
        path: '/tenant-costs',
        element: <TenantCosts />
      },
      {
        path: '/tenant-costs/create',
        element: <CreateTenantCost />
      },
      {
        path: '/tenant-costs/detail/:id',
        element: <DetailTenantCost />
      },
      {
        path: '/bookings',
        element: <Bookings />
      },
      {
        path: '/withdrawl',
        element: <Withdrawl />
      },
      {
        path: '/income',
        element: <Income />
      },
      {
        path: '/expense',
        element: <Expense />
      },
      {
        path: '/cashflow',
        element: <Cashflow />
      },
      {
        path: '/withdrawl/detail/:id',
        element: <WithdrawlDetail />
      },
      {
        path: '/bank-account',
        element: <BankAccount />
      },
      {
        path: '/bank-account/create',
        element: <CreateBankAccount />
      },
      {
        path: '/bank-account/detail/:id',
        element: <DetailBankAccount />
      },
      {
        path: '/review',
        element: <Review />
      },
      {
        path: '/bookings/detail/:id',
        element: <BookingDetail />
      }
    ]
  },
  {
    path: '*',
    element: <Navigate to="/" />
  }
];
